import SectionLabel from "@/components/base/SectionLabel";
import { dxAdvisoryData } from "@/mocks/dxAdvisoryData";

export default function WhoItIsForSection() {
  return (
    <section className="py-12 md:py-18 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="text-center mb-8 md:mb-10 reveal">
          <SectionLabel label={dxAdvisoryData.whoItIsFor.label} className="mb-3" />
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
            {dxAdvisoryData.whoItIsFor.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 max-w-4xl mx-auto">
          {/* Suitable */}
          <div className="reveal rounded-lg bg-background-50 border border-primary-200/50 p-5 md:p-6">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
                <i className="ri-check-line text-primary-600" />
              </div>
              <h3 className="text-sm md:text-base font-bold text-foreground-900 font-heading">
                {dxAdvisoryData.whoItIsFor.suitable.title}
              </h3>
            </div>
            <ul className="space-y-2">
              {dxAdvisoryData.whoItIsFor.suitable.items.map((item, i) => (
                <li key={i} className="flex items-start gap-2 text-sm text-foreground-700">
                  <i className="ri-check-line text-primary-500 mt-0.5 flex-shrink-0" />
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* Unsuitable */}
          <div className="reveal rounded-lg bg-background-50 border border-background-200/70 p-5 md:p-6">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-8 h-8 rounded-full bg-secondary-100 flex items-center justify-center">
                <i className="ri-information-line text-secondary-600" />
              </div>
              <h3 className="text-sm md:text-base font-bold text-foreground-900 font-heading">
                {dxAdvisoryData.whoItIsFor.unsuitable.title}
              </h3>
            </div>
            <ul className="space-y-2">
              {dxAdvisoryData.whoItIsFor.unsuitable.items.map((item, i) => (
                <li key={i} className="flex items-start gap-2 text-sm text-foreground-600">
                  <span className="w-1 h-1 rounded-full bg-secondary-400 mt-2 flex-shrink-0" />
                  {item}
                </li>
              ))}
            </ul>
            <p className="mt-4 text-xs text-foreground-500 bg-secondary-50/50 rounded-md p-3">
              上記に当てはまる場合でも、ご相談いただければできる範囲でのご提案や他社のご紹介を検討いたします。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}